import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '@/lib/api'

export default function AdminLogin() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('admin@fortinotech.com')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const { data } = await api.post('/auth/login', { email, password })
      localStorage.setItem('ft_token', data.token)
      localStorage.setItem('ft_admin', JSON.stringify(data.user))
      navigate('/admin')
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="admin-shell flex items-center justify-center px-4 py-10">
      <form onSubmit={onSubmit} className="w-full max-w-md admin-glass rounded-3xl p-8">
        <p className="text-xs uppercase tracking-[0.3em] text-cyan-300 mb-2">Fortino Tech</p>
        <h1 className="text-3xl font-bold mb-1">Admin Studio</h1>
        <p className="text-sky-100/70 text-sm mb-6">Sign in to manage the website</p>
        {error && <p className="mb-4 text-sm text-rose-300">{error}</p>}
        <label className="block text-sm mb-2">Email</label>
        <input className="admin-input mb-4" value={email} onChange={(e) => setEmail(e.target.value)} />
        <label className="block text-sm mb-2">Password</label>
        <input type="password" className="admin-input mb-6" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button disabled={loading} className="admin-btn w-full">
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
